import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { StorageProvider } from '../../contexts/storage';

const Private: React.FC = (props) => {
  return (
    <div className="page" style={{minHeight: "100vh"}}>
      <div className="page-main">
        <StorageProvider>
          <Header />
        </StorageProvider>
        <div>{props.children}</div>
      </div>
      <Footer />
    </div>

  );
}

export default Private;